module.exports = __webpack_public_path__ + "img/header-tel.79bb72f2.svg";